import { Component, HostListener, OnInit, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {map, mergeMap} from 'rxjs/operators';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Prestatie} from '../../../prestatie/prestatie';
import {PrestatieService} from '../../../prestatie/prestatie.service';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';
import {DienstService} from '../../../dienst/dienst.service';
import {Diensten} from '../../../dienst/diensten';
import {Dienst} from '../../../dienst/dienst';

@Component({
    templateUrl: './prestatie-diensten.page.html',
    styleUrls: ['./prestatie-diensten.page.scss'],
    standalone: false
})
export class PrestatieDienstenPage implements OnInit {
  private prestatieService = inject(PrestatieService);
  private clientService = inject(ClientService);
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private dienstService = inject(DienstService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  prestatie$: Observable<Prestatie>;
  client$: Observable<Client>;
  thuisverzorger$: Observable<Thuisverzorger>;
  diensten$: Observable<Diensten>;

  @HostListener('window:focus') onFocus() {
    window.location.reload();
  }

  ngOnInit(): void {
    this.prestatie$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('id')),
      mergeMap(id => this.prestatieService.getPrestatie$(id)),
    );
    this.client$ = this.prestatie$.pipe(
      mergeMap(prestatie => this.clientService.getClientById$(prestatie.getClientId()))
    );
    this.thuisverzorger$ = this.thuisverzorgerService.getThuisverzorgerMe$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  navigateToTaken(prestatie: Prestatie, dienst: Dienst): void {
    this.router.navigateByUrl(`/prestatie/${prestatie.getId()}/diensten/${dienst.getId()}/taken`);
  }
}
